module.exports = __webpack_public_path__ + "static/img/progress_bgc.1be2f48a.png";